import { AfterViewInit, Component, ElementRef, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToolsService } from 'src/app/services/tools/tools.service';
import { PointofsaleService } from 'src/app/services/api/pointofsale/pointofsale.service';
import { TableReservationService } from 'src/app/services/api/table-reservation/table-reservation.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { MediaObserver } from '@angular/flex-layout';
import { TableReservationClientService } from 'src/app/services/apiclient/table-reservation/table-reservation.service';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { MyStripeService } from 'src/app/services/apiclient/myStripe/my-stripe.service';
import { PaymentMethodsComponent } from '../../dialogs/payment-methods/payment-methods.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { CurrencyService } from 'src/app/services/manage/currency/currency.service';
import { ClientaccountService } from 'src/app/services/apiclient/clientaccount/clientaccount.service';
import { PayzenComponent } from 'src/app/components/dialogs/payzen/payzen.component';
import { TranslateService } from '@ngx-translate/core';
import { Renderer2, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import {AssetLoaderService} from "../../../services/asset-loader.service";
import {CssService} from "../../../services/css-service";
import { HttpClient } from '@angular/common/http';
import { LangagesService } from '../../../services/manage/langages/langages.service';


@Component({
  selector: 'app-table-reservation',
  templateUrl: './table-reservation.component.html',
  styleUrls: ['./table-reservation.component.css'],
  providers: []
})
export class TableReservationComponent implements OnInit, AfterViewInit {
  bookingActive = true;
  loaders: any = {
    page: true
  };
  user$: any;
  keyDataKlixi: any = null;
  error: any;

  constructor(
    private route: ActivatedRoute,
    public media: MediaObserver,
    public tools: ToolsService,
    private router: Router,
    private assetLoader: AssetLoaderService,
    private posApi: PointofsaleService,
    private trApiConnectill: TableReservationService,
    private trApiClient: TableReservationClientService,
    private authService: AuthService,
    private stripeApi: MyStripeService,
    private clientAccountApi: ClientaccountService,
    private dialog: MatDialog,
    private currencyMng: CurrencyService,
    private elementRef: ElementRef,
    public translate: TranslateService,
    private _renderer2: Renderer2,
    private http: HttpClient,
    public LangagesService: LangagesService,
    public cssService: CssService,
    @Inject(DOCUMENT) private _document: Document
  ) {
  }

  @HostListener('window: popstate')
  onPopState(): void {
    // changed
    if (this.tools.getOnPopState() && this.tools.getOnPopState().state) {
      history.forward();
      this.tools.setOnPopState();
    }
  }
  @HostListener("window:message", ["$event"])
  Message(event: Event): void {
    console.warn(event);
    event.preventDefault();
  }

  ngOnInit() {
    // Récupère l'utilisateur connecté
    this.authService.getUser.subscribe(user => {
      this.user$ = user;
    });
  }

  ngAfterViewInit() {
    this.handleUrlParams();
  }

  // Gère les parametre dans l'url et execute les requetes en fonction
  handleUrlParams(): void {
    this.route.params.subscribe((params: any) => {

      Promise.all([

        // Récupération des balises méta
        this.trApiConnectill.$_getBookingMeta(params.webshopId),

      ]).then(([keyData]) => {

        this.loaders.page = false;

        this.keyDataKlixi = keyData.object;

        // Récupère les booking settings ou check si bancontact -> cliensecret
        if (keyData.object.klixi_params) {
          this.loadWidget();
        }
        else{
          this.bookingActive = false;
        }
      })
    });
  }

  async loadWidget(): Promise<void> {

    const aysbe_mode = 'quicksearch';

    // Nouveau tableau des variables dynamiques du widget
    Object.entries(this.keyDataKlixi.klixi_params).forEach(([key, value]) => {
      (window as any)[key] = value;
    });

    (window as any).aysbe_mode = aysbe_mode;

    // Charger les CSS
    this.assetLoader.loadStyle('https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/12.1.4/css/intlTelInput.css');
    this.assetLoader.loadStyle('https://s3-eu-west-1.amazonaws.com/appyourself-backup/resources/be/prod/minify.css');

    // Charger les JS (dans l'ordre)
    const scripts = [
      'https://suite.appyourself.com/front/revolution-assets/plugins/jquery.min.js',
      'https://js.stripe.com/v3',
      'https://cdnjs.cloudflare.com/ajax/libs/libphonenumber-js/1.7.4/libphonenumber-js.min.js',
      'https://cdnjs.cloudflare.com/ajax/libs/babel-polyfill/7.2.5/polyfill.min.js',
      'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/12.1.4/js/intlTelInput.min.js',
      'https://s3-eu-west-1.amazonaws.com/appyourself-backup/resources/be/prod/minify.js',
      'https://suite.appyourself.com/ays/js/be_restaurant_init.js'
    ];

    for (const src of scripts) {
      await this.assetLoader.loadScript(src);
    }
  }
}
